<div class="auth-container">
    <header class="header">
        <img src="/assets/icons/avyna/logo.svg" alt="Avyna Logo" class="logo" />
        <av-language-dropdown></av-language-dropdown>
    </header>

    <main class="main-content">
        <router-outlet></router-outlet>
    </main>

    <footer class="footer">
        <div class="theme-toggle-container ms-4 mb-1">
            <app-theme-toggle></app-theme-toggle>
        </div>
        <p class="footer-text mb-1 ms-4">Avyna v{{ version }}</p>
    </footer>
</div>
